export default [
  'transfered',
  'transfer',
  'closed',
  'terminate',
  'dialogtransfered',
  'dialogtransfer',
  'dialogclosed',
  'dialogterminate',
  'exit',
];
